import React from 'react'
import { useContext } from 'react';
import { Link, useParams } from 'react-router-dom'
import { TabTitle } from '../../../../util/titleChanger'
import { GlobalState } from '../../../../GlobalState'
import { useState } from 'react';
import { useEffect } from 'react';
import { createBottleReturn, updateBottleReturn } from '../../../../action';
import { ToastContainer, toast } from 'react-toastify'
import Loading from '../../../../util/Loading'

export default function BottleReturnForm() {
    const { returnId } = useParams();
    TabTitle(returnId > 0 ? "Update Return Product" : "Return Product");

    const state = useContext(GlobalState);
    const signInUser = JSON.parse(localStorage.getItem('user_data'));

    //Local State
    const [values, setValues] = useState({});
    const [focused, setFocused] = useState(false);
    const [btnName, setBtnName] = useState("Save");
    const [productListData, setProductListData] = useState([]);
    const [addProducts, setAddProducts] = useState([]);
    const [show, setShow] = useState(false)

    //Import Bottle Return state from global state
    const [bottleReturnDetail] = state.bottleReturnAPI.bottleReturnDetail;
    const [bottleReturnId, setBottleReturnId] = state.bottleReturnAPI.bottleReturnId;
    const [callback, setCallback] = state.bottleReturnAPI.callback;
    const [bottleBalances] = state.bottleReturnAPI.bottleBalances;

    //Import customer state from global state
    const [allCustomers] = state.customerAPI.allCustomers;
    const [showCustomerSuggestions, setShowCustomerSuggestions] = useState(false);
    const [selectCustomer, setSelectCustomer] = useState("");
    const customerSuggestions = allCustomers.filter(customer =>
        customer.first_name.toString().toLowerCase().includes(selectCustomer.toString().toLowerCase())
    )

    //Import product state from global state
    const [productsList] = state.productAPI.productsList;
    const [showProductSuggestions, setShowProductSuggestions] = useState(false);
    const [selectProduct, setSelectProduct] = useState("");
    const productSuggestions = productListData.filter(product =>
        product.name.toString().toLowerCase().includes(selectProduct.toString().toLowerCase())
    )

    const handleProductSuggestionClick = (suggestion) => {
        setSelectProduct(suggestion.name)
        setShowProductSuggestions(false)
        setValues({
            ...values,
            productId: suggestion.id
        })
    }

    const onChangeSelectProduct = (e) => {
        setSelectProduct(e.target.value)
    }

    const handleCustomerSuggestionClick = (suggestion) => {
        setSelectCustomer(suggestion.first_name + " " + suggestion.last_name)
        setShowCustomerSuggestions(false)
        setValues({
            ...values,
            customerId: suggestion.id
        })
    }

    const onChangeSelectCustomer = (e) => {
        setSelectCustomer(e.target.value)
    }

    const handleFocus = (e) => {
        setFocused(false);
    }

    const addProduct = (e) => {
        e.preventDefault();

        if (!values.customerId) return toast.error("Select a Customer.");
        if (!selectProduct) return toast.error("Select a Product.");

        if(!bottleBalances){
            const balance = bottleBalances.filter(balance =>
                balance.productId === values.productId && balance.customerId === values.customerId)
    
            if (addProducts.length > 0) {
                addProducts.map(product => {
                    if (product.productId === values.productId) {
                        toast.warn("Already added this product, Please check again.")
                    } else {
                        if (balance[0].balance >= values.quantity) {
                            setAddProducts([
                                ...addProducts, {
                                    quantity: values.quantity,
                                    customerName: selectCustomer,
                                    productName: selectProduct,
                                    productId: values.productId,
                                    customerId: values.customerId,
                                }
                            ])
                        } else {
                            toast.warn("You can't add more than available return quantity!");
                        }
                    }
                })
            } else {
                if (balance[0].balance >= values.quantity) {
                    setAddProducts([
                        ...addProducts, {
                            quantity: values.quantity,
                            customerName: selectCustomer,
                            productName: selectProduct,
                            productId: values.productId,
                            customerId: values.customerId,
                        }
                    ])
                } else {
                    toast.warn("You can't add more than available return quantity!");
                }
            }
        }else{
            toast.warning("This customer haven't any bottles to return. Check selected cutomer again. Please!")
        }

        values.quantity = "0"
        values.customerName = ""
        values.productName = ""
    }

    const removeProduct = (e, index) => {
        e.preventDefault();
        const list = [...addProducts];
        list.splice(index, 1);
        setAddProducts(list)
    }

    //Get value form input elements and assign into values states
    const onChangeValue = (e) => {
        e.preventDefault();
        setValues({ ...values, [e.target.name]: e.target.value })
    }

    useEffect(() => {
        productsList.data ? setProductListData(productsList.data) : setProductListData([]);

        if (returnId > 0) {
            setBtnName("Update");
            setBottleReturnId(returnId);
            setShow(true)

            setValues({
                ...values,
                quantity: bottleReturnDetail ? bottleReturnDetail.quantity : "0",
                customerName: bottleReturnDetail.customer ? bottleReturnDetail.customer.first_name + " " + bottleReturnDetail.customer.last_name : "",
                productName: bottleReturnDetail.product ? bottleReturnDetail.product.name : "",
                productId: bottleReturnDetail.product ? bottleReturnDetail.id : "1",
                customerId: bottleReturnDetail.customer ? bottleReturnDetail.customer.id : "1",
            })

            productListData.map(product => {
                const productId = bottleReturnDetail.product ? bottleReturnDetail.product.id : "1";
                if (product.id === productId) {
                    setSelectProduct(product.name)
                }
            })

            allCustomers.map(customer => {
                const customerId = bottleReturnDetail.customer ? bottleReturnDetail.customer.id : "1";
                if (customer.id === customerId) {
                    setSelectCustomer(customer.first_name + " " + customer.last_name)
                }
            })

        }
    }, [productsList, allCustomers, bottleReturnDetail, returnId, bottleBalances])

    const onSubmit = (e) => {
        e.preventDefault();

        if (returnId > 0) {
            const proInfo = {
                quantity: values.quantity,
                productId: values.productId,
                customerId: values.customerId,
                updatedBy: signInUser.id
            }

            updateBottleReturn(returnId, proInfo, res => {
                if (res.status === 200) {
                    toast.success(res.data)
                    setCallback(!callback)
                } else {
                    toast.error(res.data)
                    setCallback(!callback)
                }
            })
        } else {
            addProducts.map(product => {
                const proInfo = {
                    quantity: product.quantity,
                    productId: product.productId,
                    customerId: values.customerId,
                    updatedBy: signInUser.id,
                    createdBy: signInUser.id,
                }

                createBottleReturn(proInfo, res => {
                    if (res.status === 200) {
                        toast.success(res.data)
                        setCallback(!callback)
                    } else {
                        toast.error(res.data)
                        setCallback(!callback)
                    }
                })
            })
        }

        setAddProducts([]);
    }
    return (
        !bottleReturnDetail ? <div className="form-container"><div className="loading-page-container"><Loading /></div></div>
            : <div className="form-container">
                <header>Bottle Return Form</header>
                <form action="" className="form">
                    <div className="input-box">
                        <label>Customer Name</label>
                        <input
                            type="text"
                            name="search"
                            id="search"
                            placeholder='Search here....'
                            value={selectCustomer}
                            onBlur={handleFocus}
                            focused={focused.toString()}
                            onChange={onChangeSelectCustomer}
                            onFocus={() => setShowCustomerSuggestions(true)}
                        />
                        {
                            showCustomerSuggestions && (
                                <ul className="suggestions">
                                    {
                                        customerSuggestions.map(suggestion => (
                                            <li key={suggestion.id} onClick={() => handleCustomerSuggestionClick(suggestion)}>
                                                {suggestion.first_name + " " + suggestion.last_name}
                                            </li>
                                        ))
                                    }
                                </ul>
                            )
                        }
                    </div>

                    <div className="input-box">
                        <label htmlFor="Name">Product Name</label>
                        <input
                            type="text"
                            name="search"
                            id="search"
                            placeholder='Search here....'
                            value={selectProduct}
                            onBlur={handleFocus}
                            focused={focused.toString()}
                            onChange={onChangeSelectProduct}
                            onFocus={() => setShowProductSuggestions(true)}
                        />
                        {
                            showProductSuggestions && (
                                <ul className="suggestions">
                                    {
                                        productSuggestions.map(suggestion => (
                                            <li key={suggestion.id} onClick={() => handleProductSuggestionClick(suggestion)}>
                                                {suggestion.name}
                                            </li>
                                        ))
                                    }
                                </ul>
                            )
                        }
                    </div>

                    <div className="input-box">
                        <label htmlFor="Name">Return Quantity</label>
                        <input
                            type="number"
                            name="quantity"
                            id="quantity"
                            placeholder='Enter Return Quantity...'
                            value={values.quantity || ""}
                            required pattern='^(?:[1-9]|\d\d\d*)$'
                            onBlur={handleFocus}
                            focused={focused.toString()}
                            onChange={onChangeValue}
                        />
                        <span>Quantity should be number and more than 1.</span>
                    </div>

                    <div className="form-button">
                        {
                            show ? <div></div>
                                : <button onClick={(e) => addProduct(e)} className="add_new">Add</button>
                        }
                    </div>

                    {
                        show ? <div></div>
                            : <div className="table_section">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Customer Name</th>
                                            <th>Product Name</th>
                                            <th>Quantity</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            addProducts.map((product, index) => (
                                                <tr key={index}>
                                                    <td>{product.customerName}</td>
                                                    <td>{product.productName}</td>
                                                    <td>{product.quantity}</td>
                                                    <td>
                                                        <Link to={'#'}></Link>
                                                        <Link to={'#'}></Link>
                                                        <button onClick={(e) => removeProduct(e, index)}><i className="uil uil-trash-alt"></i></button>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                    }
                    <div className="form-button">
                        <button onClick={(e) => { onSubmit(e) }} className="add_new">{btnName}</button>
                    </div>
                </form>
                <ToastContainer />
            </div>
    )
}
